<progress-bar class="header-progress-bar"></progress-bar>
<router-outlet></router-outlet>
